<template>
  <div id="products" class="wrapper">
    <el-row>
      <el-col :span="24">
        <div class="selectors">
          <div
            v-for="(subCategory, index) in categories"
            v-bind:key="index"
            :class="{
              selector: true,
              selected: subCategory.slug === activeSubcategory,
            }"
            v-on:click="handleClick(subCategory.slug)"
          >
            <p>{{ subCategory.title }}</p>
            <svg
              width="44"
              height="12"
              viewBox="0 0 44 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22 12L0.349366 0.749996L43.6506 0.75L22 12Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { scrollToProduct, upToSecondHash } from './product.util';

export default {
  name: 'ProductSubCategorySelector',
  props: {
    categories: {
      required: true,
      type: Array,
    },
    activeSubcategory: {
      required: true,
      type: String,
    },
  },
  computed: {
    routeHash() {
      return this.$route.hash.slice(1);
    },
  },
  methods: {
    upToSecondHash,
    handleClick(slug) {
      scrollToProduct(slug);
    },
  },
};

////////
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.wrapper {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: $--color-white;
}

.selectors {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  justify-content: space-around;
  gap: 2px;

  & .selector {
    flex: 1;
    text-align: center;
    background-color: $--color-grayscale-5;
    text-transform: uppercase;
    cursor: pointer;
    position: relative;
    padding: 22px 5px;

    @include res(sm-and-down, $--breakpoints-spec) {
      padding: 15px 5px;
    }

    & p {
      color: $--color-white;
      font-family: $font-family-headings;
      font-weight: bold;
      font-size: 14px;
      margin: 0;

      @include res(sm-and-down, $--breakpoints-spec) {
        font-size: 12px;
      }
    }

    & svg {
      display: none;
    }
  }

  & .selected {
    background-color: $--color-black;

    & svg {
      position: absolute;
      display: block;
      bottom: -11px;
      left: calc(50% - 22px);
    }
  }
}
</style>
